export const ApplicationRoutes = {
  register: '/register',
  member: '/account-created/culture/:culture/member/:id',
  sucess: '/success',
  home: '/'
}

export default ApplicationRoutes;
